import React from 'react'
import { arrayOf, string, shape, func, bool } from 'prop-types'
import { useMakeTestId } from '@divvy-web/hooks.usenameformatter'
import { groupBy } from '@divvy-web/utils'
import { css } from '@emotion/core'
import BankTile from './BankTile'

/**
This component lays out `BankTile`s into two vertical columns
*/
const BankAccountsColumns = ({ addBankMember, dataTestId, hideBalances = false, hideFix = false, members, onClickedFix, onToggleBankAccount }) => {
  const makeTestId = useMakeTestId('BankAccountsColumns', dataTestId)
  const { left = [], right = [] } = groupBy(m => members.indexOf(m) % 2 === 0 ? 'left' : 'right', members)

  return (
    <div css={containterCss}>
      <div css={banksColumnContainerCss}>
        <div css={banksLeftColumnCss}>
          {left.map(member => <span key={makeTestId(member.id)} css={tileContainerCss}><BankTile hideBalances={hideBalances} hideFix={hideFix} member={member} onClickedFix={onClickedFix} onToggleBankAccount={onToggleBankAccount} /></span>)}
        </div>
        <div css={banksRightColumnCss}>
          {right.map(member => <span key={makeTestId(member.id)} css={tileContainerCss}><BankTile hideBalances={hideBalances} hideFix={hideFix} member={member} onClickedFix={onClickedFix} onToggleBankAccount={onToggleBankAccount} /></span>)}
        </div>
      </div>
    </div>
  )
}

export const containterCss = css`
  display: flex;
  flex-direction: column;
  width: 1200px;
`

export const banksColumnContainerCss = css`
  display: flex;
  flex-flow: row;
  width: 100%;
`

export const banksLeftColumnCss = css`
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
  width: 50%;
`

export const banksRightColumnCss = css`
  display: flex;
  flex-flow: column wrap;
  width: 50%;
`

export const tileContainerCss = css`
  margin: var(--tri-space-300);
  width: 100%;
`

BankAccountsColumns.propTypes = {
  addBankMember: func,
  dataTestId: string,
  hideBalances: bool,
  hideFix: bool,
  members: arrayOf(shape({
    id: string,
    institutionName: string,
    logoUrl: string,
    status: string
  })).isRequired,
  onClickedFix: func,
  onToggleBankAccount: func
}

export default BankAccountsColumns
